module.exports = __webpack_public_path__ + "img/荣誉证书08_软件产品证书.7c165945.png";